(ns ui.view.card.counterparty-diligence-answers.model)

(def form-state-path [:form-state])

(defn form-state-full-path
  [card-state-path]
  (into card-state-path form-state-path))
